import request from '@/utils/request.js'

export default {
    //检索
    search(params){
        return request({
            url: '/api/info/search',
            method: 'GET',
            params
        })
    }
}